import proxyRules from '../../proxyConfig/rules'

export const rewritePath = ({
  path,
  baseURL: defaultBaseURL,
  searchParams
}) => {
  let urlToParse = (defaultBaseURL || window.location.origin) + path
  if (path.startsWith('http://') || path.startsWith('https://')) {
    urlToParse = path
  }

  const urlParts = new URL(urlToParse)
  const { search } = urlParts
  path = urlParts.pathname
  defaultBaseURL = urlParts.origin

  let result = { path, baseURL: defaultBaseURL }
  let targetPath = path
  let baseURL = defaultBaseURL

  proxyRules.some((rule) => {
    if (rule.from.test(path)) {
      targetPath = path.replace(rule.from, rule.to)
      baseURL = rule.target || defaultBaseURL
      result = { path: targetPath, baseURL }
      return true
    }
    return false
  })

  const baseURLLocation = new URL(result.baseURL)
  const pathPrefix = baseURLLocation.pathname.replace('/', '')
  const finalPath = pathPrefix + result.path
  const finalURL = new URL(finalPath, baseURLLocation.origin)
  if (searchParams || search) {
    finalURL.search = search || new URLSearchParams(searchParams)
  }

  result = {
    path: finalPath + search,
    baseURL: baseURLLocation.origin,
    url: finalURL
  }

  return result
}
